import Reveal from "@/components/Reveal";
import { ArrowUpRight, Clock, Euro } from "lucide-react";
import { scrollToSection } from "@/components/Header";

const TREATMENTS = [
  {
    n: "01",
    title: "Fisioterapia per Anziani",
    desc: "Percorsi dolci e progressivi per tornare a muoversi bene: recupero dell'autonomia quotidiana, prevenzione delle cadute e, quando necessario, disallettamento con esercizi mirati.",
  },
  {
    n: "02",
    title: "Riabilitazione Post-Operatoria",
    desc: "Dopo l'intervento ogni giorno conta: un percorso sicuro e progressivo, in sinergia con il tuo chirurgo, per recuperare forza e movimento il prima possibile.",
  },
  {
    n: "03",
    title: "Ritorno alle Attività Quotidiane e Sportive",
    desc: "Qualunque sia la causa — un'operazione, una malattia o un dolore persistente — costruiamo insieme il percorso per riportarti alla tua vita di sempre: dal lavoro allo sport.",
  },
  {
    n: "04",
    title: "Trattamento dei Dolori Cronici",
    desc: "Mal di schiena, cervicalgie e dolori che durano da mesi: un approccio mirato che lavora sulle cause e non solo sui sintomi, per restituirti la libertà di muoverti.",
  },
  {
    n: "05",
    title: "Recupero Post-Infortunio",
    desc: "Distorsioni, stiramenti, contratture e traumi: un percorso mirato per tornare a muoverti in sicurezza, con i tempi giusti e senza ricadute.",
  },
];

export default function Treatments() {
  return (
    <section id="trattamenti" data-testid="treatments-section" className="py-24 lg:py-32 bg-cream border-y border-pine/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-terracotta mb-4">Trattamenti</p>
              <h2 className="font-serif tracking-tight text-pine text-3xl sm:text-4xl lg:text-5xl max-w-xl">
                Cure mirate, senza muoverti da casa.
              </h2>
            </div>
            <div className="max-w-sm">
              <p className="text-sm text-moss leading-relaxed">
                Ogni percorso inizia con una valutazione completa e prosegue con obiettivi condivisi,
                verificati seduta dopo seduta.
              </p>
              <div data-testid="treatments-studio-note" className="mt-6 border-l-[3px] border-terracotta pl-5">
                <p className="font-serif italic text-lg lg:text-xl text-pine leading-snug">
                  Oppure in studio: nel nuovo centro di{" "}
                  <span className="not-italic font-semibold text-terracotta">Fisioterapia Italia Torino</span>,
                  con una fisiopalestra grande e moderna e tecnologie all'avanguardia.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
        <div>
          {TREATMENTS.map((t, i) => (
            <Reveal key={t.n} delay={i * 0.06}>
              <button
                data-testid={`treatment-item-${t.n}`}
                onClick={() => scrollToSection("contatti")}
                className="group w-full text-left border-t border-pine/15 py-8 lg:py-10 grid md:grid-cols-12 gap-4 items-baseline hover:bg-bone transition-colors duration-300 px-2 lg:px-4"
              >
                <span className="md:col-span-1 font-serif text-2xl text-terracotta">{t.n}</span>
                <span className="md:col-span-4 font-serif text-2xl lg:text-3xl text-pine tracking-tight group-hover:text-terracotta transition-colors duration-300">
                  {t.title}
                </span>
                <span className="md:col-span-6 text-sm text-moss leading-relaxed">{t.desc}</span>
                <span className="md:col-span-1 flex md:justify-end">
                  <ArrowUpRight size={18} strokeWidth={1.5} className="text-terracotta opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                </span>
              </button>
            </Reveal>
          ))}
          <div className="border-t border-pine/15" />
          <Reveal delay={0.1}>
            <div data-testid="pricing-note" className="mt-8 bg-pine text-bone rounded-md p-6 lg:p-8 flex flex-col sm:flex-row sm:items-center gap-6 justify-between">
              <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
                <p className="flex items-center gap-2.5 font-serif text-xl lg:text-2xl tracking-tight">
                  <Clock size={20} strokeWidth={1.5} className="text-terracotta" /> 30–60 minuti a seduta
                </p>
                <p className="flex items-center gap-2.5 font-serif text-xl lg:text-2xl tracking-tight">
                  <Euro size={20} strokeWidth={1.5} className="text-terracotta" /> A partire da 50 €
                </p>
              </div>
              <p className="text-sm text-bone/70 leading-relaxed max-w-md">
                Tutte le prestazioni sono detraibili fiscalmente come spese mediche:
                ricevi regolare ricevuta a fine seduta.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
